<template>
    <div class="home">
        <div class="content">
            <div class="amount-head">
                <div class="amount-title">
                    <div class="amount-title-left">提现金额</div>
                    <div class="amount-title-right" @click="toDescribe()">提现说明</div>
                </div>
                <div class="amount-num">
                    <div class="amount-num-left">
                        <div class="amount-num-symbol">&yen;</div>
                        <van-field v-model="countValue" class="amount-num-input"
                            :placeholder="'账户余额' + bankInfo.balance + '元'" type="number" max="20000" min="100"
                            @input="limitNum()" @change="countRealNum()"></van-field>
                    </div>
                    <div class="amount-num-all" @click="fillUp()">全部</div>
                </div>
                <div class="amount-tips">
                    每次提现金额不少于100元，且不超过20000元，同一身份用户每月只能申请1次。到账金额仅供参考，当月同一身份用户提现超过800元需要扣除个税，以完税后实到为准。
                </div>
            </div>
            <div class="amount-real">
                <div class="amount-title">
                    <div class="amount-title-left">实际到账金额</div>
                </div>
                <div class="amount-num-real">
                    <div class="amount-num-symbol-real">&yen;</div>
                    <div class="amount-num-count">{{ countValueReal }}元</div>
                </div>
            </div>
            <div class="amount-bind" v-if="bankInfo.bankStatus === '0'">
                <div class="amount-bind-left">
                    <div class="amount-bind-title">请绑定银行卡</div>
                    <div class="amount-bind-subtitle">完成实名认证，以保障资金安全和使用提现功能。</div>
                </div>
                <div class="bind-btn" @click="toResetBind()">去绑定</div>
            </div>
            <div ref="htmlContent" style="display: none;">
                <div class="apply-sucess-icon">
                    <img src="../assets/image/bindBank-icon.png" />
                    <div class="apply-sucess-title">申请已提交</div>
                    <div class="apply-sucess-subtitle">资金预计在提交申请后第二个月15日内到账</div>
                </div>
            </div>
            <div class="amount-bank" v-if="bankInfo.bankStatus === '1'">
                <div class="amount-title">
                    <div class="amount-title-left">提现到银行卡</div>
                </div>
                <div class="amount-bankInfo">
                    <div class="amount-bankInfo-each">开户行：{{ bankInfo.branchName }}</div>
                    <div class="amount-bankInfo-each">银行卡：{{ bankInfo.bankNo }}</div>
                </div>
                <div class="amount-resetBind-btn" @click="toResetBind()">重新绑定</div>
            </div>
            <div class="all-btn">
                <div class="over-btn" :class="{ 'stop': bankInfo.bankStatus === '0' || countValueReal === 0 }"
                    @click="submit()">提交</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getStudentBankInfo, getRealityTotal, addStudentDrawRecord } from '@/api/common'   //路径
import { showDialog } from 'vant';
export default {
    name: 'PersonPage',
    props: ['id'],
    data() {
        return {
            merchantId: '',
            bankInfo: {
                bankNo: '',
                name: '',
                branchName: '',
                phone: '',
                idcard: '',
                bankStatus: '',
                balance: 0
            },
            countValue: '',
            countValueReal: 0,
            isMax: false
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.getStudentBank();
    },
    methods: {
        getStudentBank() {
            let that = this;
            let params = {};
            getStudentBankInfo(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    that.bankInfo = res.data;
                }
            })
        },
        toResetBind() {
            this.$router.push({
                path: '/bindBank/' + this.merchantId, query: {
                    bankStatus: '0',
                }
            });
        },
        fillUp() {
            if (this.bankInfo.bankStatus === '0') {
                return;
            }
            if(this.bankInfo.balance > 20000) {
                this.countValue = 20000;
            } else {
                this.countValue = this.bankInfo.balance;
            }
            this.countRealNum();
        },
        countRealNum() {
            if (Number.isNaN(this.countValue) || this.countValue === 0 || this.countValue === '') {
                this.countValueReal = 0;
                return;
            }
            if (this.countValue < 100) {
                this.countValue = 100;
            }
            let that = this;
            let params = {
                applyTotal: this.countValue
            };
            getRealityTotal(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                    that.countValueReal = 0;
                } else {
                    that.countValueReal = res.realityTotal;
                }
            })
        },
        limitNum() {
            if (this.countValue > 20000) {
                this.countValue = 20000;
                if (!this.isMax) {
                    this.isMax = true;
                    this.countRealNum();
                }
                return;
            }
            if (this.countValue > this.bankInfo.balance) {
                this.countValue = this.bankInfo.balance;
                if(!this.isMax) {
                    this.isMax = true;
                    this.countRealNum();
                }
                return;
            }
            this.isMax = false;
        },
        submit() {
            if (this.bankInfo.bankStatus === '0' || this.countValueReal === 0) {
                return;
            }
            if (this.countValue === '') {
                this.$message.error("请输入提现余额");
                return;
            }
            if (Number.isNaN(this.countValue) || this.countValue === 0) {
                return;
            }
            let that = this;
            let params = {
                applyTotal: this.countValue
            }
            addStudentDrawRecord(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    const htmlContent = this.$refs.htmlContent.innerHTML;
                    showDialog({
                        message: htmlContent,
                        allowHtml: true
                    }).then(() => {
                        that.$router.push({ path: '/cashback/' + that.merchantId });
                    });
                }
            })
        },
        toDescribe() {
            this.$router.push({ path: '/cashbackDescribe/' + this.merchantId });
        }
    }
}
</script>
<style scoped>
.content {
    min-height: 100vh;
    background-color: #fafafa;
}

.amount-head {
    padding: 15px;
    margin-bottom: 5px;
    background-color: #fff;
    overflow: hidden;
}

.amount-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
}

.amount-title-left {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 500;
}

.amount-title-right {
    font-size: 14px;
    color: #333333;
}

.amount-num {
    padding-bottom: 12px;
    margin-bottom: 9px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E5E5E5;
}

.amount-num-left {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.amount-num-symbol {
    margin-right: 5px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
}

.amount-num-input {
    flex: 1;
    padding: 0;
    border: 0;
    font-size: 24px;
    line-height: 33px;
}

.amount-num-all {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #0095D9;
    font-weight: 500;
}

.amount-num-input::-webkit-input-placeholder {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
}

.amount-tips {
    text-align: left;
    font-size: 14px;
    color: #6D7278;
}

.amount-real {
    padding: 15px;
    background-color: #fff;
    overflow: hidden;
}

.amount-num-real {
    display: flex;
    align-items: center;
}

.amount-num-symbol-real {
    margin-right: 5px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #F11515;
    letter-spacing: 0;
    font-weight: 500;
}

.amount-num-count {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #F11515;
    letter-spacing: 0;
    font-weight: 400;
}

.amount-bank {
    padding: 15px;
    margin-top: 10px;
    background-color: #fff;
    overflow: hidden;
}

.amount-bankInfo {
    overflow: hidden;
    border-bottom: 1px solid #E5E5E5;
}

.amount-bankInfo-each {
    text-align: left;
    margin-bottom: 10px;
    font-size: 14px;
    color: #333333;
}

.amount-resetBind-btn {
    margin-top: 10px;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #0095D9;
    letter-spacing: 0;
    font-weight: 500;
    text-align: center;
}

.all-btn {
    margin-top: 25px;
    padding: 0 40px;
    overflow: hidden;
}

.over-btn {
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #0095D9;
    border-radius: 32px;
}

.stop {
    background: #CCCCCC;
}

.amount-bind {
    display: flex;
    align-items: center;
    padding: 10px 20px 14px 20px;
    margin: 15px 15px 0 15px;
    border-radius: 5px;
    background-color: #fff;
}

.bind-btn {
    width: 68px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
    background: #0095D9;
    border-radius: 15.5px;
}

.amount-bind-left {
    flex: 1;
    padding-right: 10px;
    text-align: left;
    overflow: hidden;
}

.amount-bind-title {
    margin-bottom: 2px;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
}

.amount-bind-subtitle {
    width: 180px;
    font-size: 12px;
    color: #999999;
}

.apply-sucess-icon {
    overflow: hidden;
}

.apply-sucess-icon img {
    margin-bottom: 20px;
    width: 48px;
    height: 48px;
}

.apply-sucess-title {
    margin-bottom: 12px;
    font-size: 14px;
    color: #333333;
}

.apply-sucess-subtitle {
    font-size: 12px;
    color: #999999;
}
</style>